var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "sidebar-widget",
    },
    [
      _vm.title
        ? _c(
            "div",
            {
              staticClass: "sidebar-widget-header",
            },
            [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
              this.$slots.actions
                ? _c(
                    "div",
                    {
                      staticClass: "actions",
                    },
                    [_vm._t("actions")],
                    2
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scrollable",
          staticClass: "sidebar-widget-content",
        },
        [_vm._t("content")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }